var cilArrowThickFromTop = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M336,113.375H176v144H56V296L255.8,496,456,296.007V257.375H336Zm81.361,176L255.826,450.746,94.616,289.375H208v-144h96v144Z' class='ci-primary'/><rect width='400' height='32' x='56' y='17.376' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickFromTop };

